import request from '@/utils/request'

export function selectPointConsume(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/pointConsume/selectPointConsume?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}




export function getBalance(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/point/v2/getBalance?access=${data}`,
        method: 'post',
        data,
    })
}



